import { Outlet, useLocation } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import { Navbar } from '@/components/common/Navbar';
import { Footer } from '@/components/common/Footer';
import { ScrollTrigger } from '@/lib/gsap-config';
import { mountSmoothScroll, scrollToTarget } from '@/lib/smooth-scroll';

export default function MainLayout() {
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => mountSmoothScroll(), []);

  useEffect(() => {
    // Cancel any in-flight anchor scroll when a route replaces the current page.
    scrollToTarget(0, { immediate: true });
    let cancelled = false;
    const refresh = () => {
      if (cancelled) return;
      ScrollTrigger.sort();
      ScrollTrigger.refresh();
    };
    const timer = window.setTimeout(() => {
      refresh();
      const target = location.hash
        ? document.getElementById(location.hash.slice(1))
        : mainRef.current?.querySelector<HTMLElement>('h1');
      if (location.hash && target) scrollToTarget(target, { offset: -80, immediate: true });
      if (target) {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }, 80);
    void document.fonts.ready.then(refresh);
    return () => { cancelled = true; window.clearTimeout(timer); };
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-background text-foreground antialiased selection:bg-brand selection:text-white">
      <Navbar />
      <div className="flex flex-col min-h-screen">
        <main ref={mainRef} className="flex-1"><Outlet /></main>
        <Footer />
      </div>
    </div>
  );
}
